export default "__VITE_ASSET__DfDi9Ykq__"